// chamaTheme.js — only MinoLogo remains, everything else unused
import React from 'react';

export const MinoLogo = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 38 38" fill="none">
    <rect x="1" y="1" width="36" height="36" rx="9" fill="#050505" stroke="#1a1a1e" strokeWidth="1.5"/>
    <line x1="11" y1="30" x2="20" y2="8" stroke="#3772ff" strokeWidth="2.5" strokeLinecap="round"/>
    <line x1="19" y1="30" x2="28" y2="8" stroke="#16c784" strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
);

// Legacy exports kept to avoid import errors during migration
export const theme = {};
export const glassCard = {};
export const glassPanel = {};
export const inputStyle = {};
export const btnPrimary = {};
export const btnGhost = {};
export const GraphiteNoise = () => null;
export const GlowOrb = () => null;
export const FadeUp = ({ children, style = {} }) => <div style={style}>{children}</div>;